module.exports = __webpack_public_path__ + "static/img/zl2.7ed08d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/zl2.png
// module id = qK7/
// module chunks = 7